import React from 'react';
import CameraStreamOneComponent from "../components/cameraStreamOneComponent";

const CameraStreamOnePage = () => {
    return (
        <CameraStreamOneComponent/>
    );
};

export default CameraStreamOnePage;